module.exports = __webpack_public_path__ + "img/position-rejected-selected.57699f57.svg";